import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import styles from "./CreatorTerms.module.scss";
import { LEGAL_CONFIG } from "../../../config/legal";

const CreatorTerms = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>
          <FormattedMessage
            id="legal.creator.title"
            defaultMessage="Creator cooperation terms for {platform}"
            values={{ platform: LEGAL_CONFIG.platformName.toUpperCase() }}
          />
        </h1>

        <section className={styles.section}>
          <h2>§1 Postanowienia ogolne</h2>
          <p>
            Niniejszy regulamin okresla zasady wspolpracy pomiedzy Operatorem
            Platformy {LEGAL_CONFIG.platformName} a Tworcami.
          </p>
        </section>

        <section className={styles.section}>
          <h2>§2 Warunki uczestnictwa</h2>
          <p>
            Tworca oswiadcza, ze posiada pelne prawa autorskie do publikowanych
            materialow.
          </p>
        </section>

        <section className={styles.section}>
          <h2>§3 Obowiazki Tworcy</h2>
          <p>
            Tworca zobowiazuje sie do dostarczania tresci zgodnych z prawem i
            regulaminem.
          </p>
        </section>

        <section className={styles.section}>
          <h2>§4 Rozliczenia</h2>
          <p>Rozliczenia odbywaja sie na podstawie indywidualnej umowy.</p>
        </section>

        <section className={styles.section}>
          <h2>§5 Ochrona danych (RODO)</h2>
          <p>
            Dane osobowe przetwarzane sa zgodnie z RODO i{" "}
            <Link to="/privacy-policy" className={styles.inlineLink}>
              {
              <FormattedMessage id="legal.privacy.link" defaultMessage="privacy policy" />
            }
            </Link>
            .
          </p>
        </section>

        <section className={styles.section}>
          <h2>§6 Oplaty, prowizje i rejestracja</h2>
          <ol>
            <li>Rejestracja konta Tworcy na Platformie jest bezplatna.</li>
            <li>
              Platforma nie pobiera oplat abonamentowych ani oplat za utrzymanie
              konta.
            </li>
            <li>
              Operator Platformy pobiera wylacznie prowizje od sprzedazy
              Produktow Cyfrowych Tworcy.
            </li>
            <li>
              Wysokosc prowizji ustalana jest indywidualnie lub publikowana w
              aktualnym cenniku dostepnym na Platformie.
            </li>
            <li>
              Operator zastrzega sobie prawo do zmiany wysokosci prowizji z
              zachowaniem co najmniej 14-dniowego okresu informacyjnego.
            </li>
            <li>Prowizja naliczana jest od ceny brutto sprzedazy Produktu.</li>
            <li>
              Rozliczenia z Tworca dokonywane sa w cyklach miesiecznych, na
              podstawie zestawien sprzedazowych.
            </li>
            <li>
              Tworca zobowiazany jest do wystawienia faktury lub innego
              dokumentu ksiegowego zgodnie z obowiazujacymi przepisami.
            </li>
            <li>
              Operator ma prawo wstrzymac wyplate srodkow w przypadku naruszenia
              Regulaminu.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§7 Dodatkowe zasady wspolpracy</h2>
          <ol>
            <li>
              Tworca zobowiazuje sie do aktualizowania swoich danych kontaktowych
              i rozliczeniowych.
            </li>
            <li>
              Tworca ponosi pelna odpowiedzialnosc za tresci publikowane na
              Platformie.
            </li>
            <li>
              Zabrania sie publikowania tresci sprzecznych z prawem, dobrymi
              obyczajami lub regulaminem.
            </li>
            <li>
              Operator ma prawo do czasowego zawieszenia konta w przypadku
              podejrzenia naruszen.
            </li>
            <li>
              Tworca zobowiazuje sie do wspolpracy w zakresie obslugi reklamacji.
            </li>
            <li>
              Tworca nie moze wykorzystywac Platformy ani jej bazy klientow do
              dzialan majacych na celu omijanie prowizji naleznej Platformie, w
              szczegolnosci poprzez przekierowywanie klientow do sprzedazy poza
              systemem Platformy. Tworca zachowuje prawo do sprzedazy swoich
              Produktow takze w innych kanalach.
            </li>
            <li>
              Wszelkie spory beda rozstrzygane w pierwszej kolejnosci polubownie.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§8 Postanowienia koncowe</h2>
          <p>Regulamin podlega prawu polskiemu.</p>
        </section>
      </div>
    </div>
  );
};

export default CreatorTerms;
